import React from 'react';
import { cn } from '../../utils/cn';
import BeatLoader from 'react-spinners/BeatLoader';

const LoadingSpinner = ({ 
  size = 'md', 
  className,
  text,
  ...props 
}) => {
  const sizeMap = { sm: 8, md: 12, lg: 16, xl: 20 };

  const isSmall = size === 'sm';
  const containerBase = 'flex items-center justify-center w-full';
  const containerCentered = isSmall ? '' : 'min-h-[50vh]';

  return (
    <div className={cn(containerBase, containerCentered, className)} {...props}>
      <BeatLoader color="#3B82F6" size={sizeMap[size] || sizeMap.md} loading={true} />
      {text && (
        <span className="ml-3 text-gray-600 dark:text-gray-400">
          {text}
        </span>
      )}
    </div>
  );
};

export default LoadingSpinner;